import { render, staticRenderFns } from "./PreviousObservations.vue?vue&type=template&id=d6ec3970"
import script from "./PreviousObservations.vue?vue&type=script&lang=js"
export * from "./PreviousObservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports